/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const Origin = core.serialization.object({
    id: core.serialization.string().optional(),
    slug: core.serialization.string().optional(),
});
